module.exports = __webpack_public_path__ + "static/media/pegasus.0394ad05.svg";